module.exports = __webpack_public_path__ + "img/permintaan.3a14ff82.svg";